var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteHouse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/house") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/house",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/house"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3, 3.6)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5326402,10.0996875 L12.8001402,0.3189375 C12.3343902,-0.1063125 11.6256402,-0.1063125 11.1396402,0.3189375 L0.407140182,10.0996875 C0.0223901818,10.4439375 -0.0991098182,10.9704375 0.0831401818,11.4564375 C0.265390182,11.9424375 0.710890182,12.2461875 1.21714018,12.2461875 L2.93839018,12.2461875 L2.93839018,22.0471875 C2.93839018,22.4319375 3.26239018,22.7559375 3.64714018,22.7559375 L9.53989018,22.7559375 C9.92464018,22.7559375 10.2486402,22.4319375 10.2486402,22.0471875 L10.2486402,16.0936875 L13.7113902,16.0936875 L13.7113902,22.0471875 C13.7113902,22.4319375 14.0353902,22.7559375 14.4201402,22.7559375 L20.3128902,22.7559375 C20.6976402,22.7559375 21.0216402,22.4319375 21.0216402,22.0471875 L21.0216402,12.2461875 L22.7428902,12.2461875 C23.2491402,12.2461875 23.6946402,11.9424375 23.8768902,11.4564375 C24.0388902,10.9704375 23.8971402,10.4439375 23.5326402,10.0996875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7988902,1.4124375 L16.0806402,1.4124375 L21.5076402,6.3534375 L21.5076402,2.1211875 C21.5076402,1.7161875 21.1836402,1.4124375 20.7988902,1.4124375 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-house.7bbd3458abfdfe6fac729bb63e4f6cc3.svg";